"use strict";
var variance = require('compute-variance');
var fifoSize = null;
var fifo = null;
var fifoLastIndex = null;
var fifoFirstIndex = null;

function fifoInit(size) {
    fifoSize = size;
    fifo = [];
    return fifo.length;
}
function fifoAdd(object) {
    fifo.push[object];
    fifo.push(object);
    if (fifo.length > fifoSize) fifo.splice(0, 1);
    return fifo.length;
}
function fifoRemove(index) {
    if (index < 0) return -1;
    if (index >= fifo.length) return -1;
    fifo.splice(index, 1);
    return fifo.length;
}
function fifoRemoveLast() {
    fifo.splice(fifo.length - 1, 1);
    return fifo.length;
}
module.exports = {
    variance: function (array) {
        if (array.length == 0) return 0;
        return variance(array);
    },
    average: function (array) {
        var sum = 0;
        var length = array.length;
        if (length == 0) {
            console.log('average cannot be counted from empty array');
            return null;
        }
        for (var i = 0; i < length; i++)sum += array[i];
        return sum / length;
    },
    sum: function (array) {
        var sum = 0;
        var length = array.length;
        if (length == 0) {
            console.log('sum cannot be counted from empty array');
            return null;
        }
        for (var i = 0; i < length; i++)sum += array[i];
        return sum;
    },
    min: function (array) {
        var min = 1000000;
        var length = array.length;
        if (length == 0) {
            console.log('min cannot be calculated from empty array');
            return null;
        }
        for (var i = 0; i < length; i++) {
            if (array[i] < min) min = array[i];
        }
        return min;
    },
    median: function (array) {
        var newArray = []
        if (array.length == 0) return array
        for (var i = 0; i < array.length; i++)newArray.push(array[i])
        newArray.sort(function (a, b) { return a - b })
        return newArray[(array.length / 2) | 0]
    },
    minIndex: function (array) {
        var min = 1000000;
        var index = null;
        var length = array.length;
        if (length == 0) {
            console.log('min cannot be calculated from empty array');
            return null;
        }
        for (var i = 0; i < length; i++) {
            if (array[i] < min) {
                min = array[i];
                index = i;
            }
        }
        return index;
    },
    max: function (array) {
        var max = -1000000;
        var length = array.length;
        if (length == 0) {
            console.log('max cannot be calculated from empty array');
            return null;
        }
        for (var i = 0; i < length; i++) {
            if (array[i] > max) max = array[i];
        }
        return max;
    },
    maxIndex: function (array) {
        var max = -1000000;
        var index = null;
        var length = array.length;
        if (length == 0) {
            console.log('max cannot be calculated from empty array');
            return null;
        }
        for (var i = 0; i < length; i++) {
            if (array[i] > max) {
                max = array[i];
                index = i;
            }
        }
        return index;
    },
    fifoInit: function (size) {
        return fifoInit(size);
    },
    fifoAdd: function (index) {
        return fifoAdd(index);
    },
    fifoRemove: function (index) {
        return fifoRemove(index);
    },
    fifoRemoveLast: function () {
        return fifoRemoveLast();
    },
    fifo: function () {
        return fifo;
    }

}


//////////////////
// WEBPACK FOOTER
// ./~/@smartvatten/digitreader2/mathTimo.js
// module id = 174
// module chunks = 0